<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import appConfig from "@/app.config";
import categorySvc from "@/services/category";
import { toast } from "vue3-toastify";

/**
 * Customers component
 */
export default {
  page: {
    title: "Category",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Category",
      items: [
        {
          text: "Setting",
          href: "#",
        },
        {
          text: "Category",
          active: true,
        },
      ],
      columns: [
        {
          field: "uuid",
          hidden: true,
        },
        {
          label: "Name (TH)",
          field: "name",
        },
        {
          label: "Name (EN)",
          field: "nameEn",
        },
        {
          label: "Color",
          field: "color",
        },
        {
          label: "Status",
          field: "isActive",
        },
        {
          label: "Action",
          field: "button",
          html: true,
          sortable: false,
          tdClass: "text-center",
          thClass: "text-center",
        },
      ],
      rows: [],
      showModalCreate: false,
      showModalEdit: false,
      submitted: false,
      category: {
        title: "",
        titleEn: "",
        uuid: "",
        name: "",
        nameEn: "",
        color: "",
        status: "",
      },
      categoryList: [],
      categoryListEn: [],
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations: {
    category: {
      name: {
        required: helpers.withMessage("name (TH) is required", required),
      },
      nameEn: {
        required: helpers.withMessage("name (EN) is required", required),
      },
      color: {
        required: helpers.withMessage("color is required", required),
      },
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    get() {
      categorySvc.getAll().then((resp) => {
        if (resp.data.data === null) {
          return;
        } else {
          this.rows = resp.data.data;
          resp.data.data.forEach((category) => {
            this.categoryList.push(category.name);
            this.categoryListEn.push(category.nameEn);
          });
        }
      });
    },
    create() {
      this.category.uuid = "";
      this.category.name = "";
      this.category.nameEn = "";
      this.category.color = "";
      this.category.status = "";
      this.submitted = false;
      this.showModalCreate = true;
    },

    edit(data) {
      this.category.title = data.name;
      this.category.titleEn = data.nameEn;
      this.category.uuid = data.uuid;
      this.category.name = data.name;
      this.category.nameEn = data.nameEn;
      this.category.color = data.color;
      this.submitted = false;
      this.showModalEdit = true;
    },
    editStatus(uuid) {
      categorySvc
        .updateStatus(uuid)
        .then((resp) => {
          if (resp.status === 200) {
            toast.success("Update Status Successfully", {
              autoClose: localStorage.getItem("toastCountdown"),
            });
          } else {
            toast.error("Update Status Failed", {
              autoClose: localStorage.getItem("toastCountdown"),
            });
          }
        })
        .catch((err) => {
          toast.error(err, {
            autoClose: localStorage.getItem("toastCountdown"),
          });
        })
        .finally(() => {
          this.get();
        });
    },
    async handleSubmit() {
      this.submitted = true;
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      } else {
        if (
          this.categoryList.includes(this.category.name) ||
          this.categoryListEn.includes(this.category.nameEn)
        ) {
          toast.error("this category has already been used", {
            autoClose: localStorage.getItem("toastCountdown"),
          });
          return;
        }
        await categorySvc.create(this.category);

        toast.success("Created Successfully", {
          autoClose: localStorage.getItem("toastCountdown"),
        });

        this.get();
        this.showModalCreate = false;
      }
    },
    async handleEditSubmit() {
      this.submitted = true;
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      } else {
        if (
          (this.categoryList.includes(this.category.name) &&
            this.category.title !== this.category.name) ||
          (this.categoryListEn.includes(this.category.nameEn) &&
            this.category.titleEn !== this.category.nameEn)
        ) {
          toast.error("this category has already been used", {
            autoClose: localStorage.getItem("toastCountdown"),
          });
          return;
        }
        await categorySvc.update(this.category.uuid, this.category);

        toast.success("Updated Successfully", {
          autoClose: localStorage.getItem("toastCountdown"),
        });

        this.get();
        this.showModalEdit = false;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-12">
                <!-- MODAL CREATE -->
                <div class="text-sm-end">
                  <button
                    type="button"
                    class="btn btn-success btn-rounded mb-2 me-2"
                    @click="create"
                  >
                    <i class="mdi mdi-plus me-1"></i> Add Category
                  </button>
                  <b-modal
                    v-model="showModalCreate"
                    title="Add Category"
                    title-class="text-black font-18"
                    body-class="p-3"
                    hide-footer
                    no-close-on-backdrop
                  >
                    <form @submit.prevent="handleSubmit">
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            <label for="text"
                              >Name (TH)
                              <span class="is-required">*</span>
                            </label>
                            <input
                              id="text"
                              v-model="category.name"
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid':
                                  submitted && v$.category.name.$error,
                              }"
                            />

                            <div
                              v-if="submitted && v$.category.name.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="v$.category.name.required.$message">{{
                                v$.category.name.required.$message
                              }}</span>
                            </div>
                          </div>
                          <div class="mb-3">
                            <label for="text"
                              >Name (EN)
                              <span class="is-required">*</span></label
                            >
                            <input
                              id="text"
                              v-model="category.nameEn"
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid':
                                  submitted && v$.category.nameEn.$error,
                              }"
                            />

                            <div
                              v-if="submitted && v$.category.nameEn.$error"
                              class="invalid-feedback"
                            >
                              <span
                                v-if="v$.category.nameEn.required.$message"
                                >{{
                                  v$.category.nameEn.required.$message
                                }}</span
                              >
                            </div>
                          </div>
                          <div class="mb-3">
                            <label for="text"
                              >Color Code
                              <span class="is-required">*</span></label
                            >
                            <input
                              id="text"
                              v-model="category.color"
                              type="text"
                              class="form-control"
                              placeholder="#ffffff"
                              :class="{
                                'is-invalid':
                                  submitted && v$.category.color.$error,
                              }"
                            />

                            <div
                              v-if="submitted && v$.category.color.$error"
                              class="invalid-feedback"
                            >
                              <span
                                v-if="v$.category.color.required.$message"
                                >{{ v$.category.color.required.$message }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="text-end pt-5 mt-3">
                        <b-button
                          variant="light"
                          @click="showModalCreate = false"
                          >Close</b-button
                        >
                        <b-button type="submit" variant="success" class="ms-1"
                          >Create Category</b-button
                        >
                      </div>
                    </form>
                  </b-modal>
                </div>
                <!-- MODAL CREATE -->

                <!-- MODAL EDIT -->
                <div class="text-sm-end">
                  <b-modal
                    v-model="showModalEdit"
                    :title="`Edit Category : ${category.title} / ${category.titleEn}`"
                    title-class="text-black font-18"
                    body-class="p-3"
                    hide-footer
                    no-close-on-backdrop
                  >
                    <form @submit.prevent="handleEditSubmit">
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            <label for="text"
                              >Name (TH)
                              <span class="is-required">*</span></label
                            >
                            <input
                              id="text"
                              v-model="category.name"
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid':
                                  submitted && v$.category.name.$error,
                              }"
                            />

                            <div
                              v-if="submitted && v$.category.name.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="v$.category.name.required.$message">{{
                                v$.category.name.required.$message
                              }}</span>
                            </div>
                          </div>
                          <div class="mb-3">
                            <label for="text"
                              >Name (EN)
                              <span class="is-required">*</span></label
                            >
                            <input
                              id="text"
                              v-model="category.nameEn"
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid':
                                  submitted && v$.category.nameEn.$error,
                              }"
                            />

                            <div
                              v-if="submitted && v$.category.nameEn.$error"
                              class="invalid-feedback"
                            >
                              <span
                                v-if="v$.category.nameEn.required.$message"
                                >{{
                                  v$.category.nameEn.required.$message
                                }}</span
                              >
                            </div>
                          </div>
                          <div class="mb-3">
                            <label for="text"
                              >Color Code
                              <span class="is-required">*</span></label
                            >
                            <input
                              id="text"
                              v-model="category.color"
                              type="text"
                              class="form-control"
                              placeholder="#ffffff"
                              :class="{
                                'is-invalid':
                                  submitted && v$.category.color.$error,
                              }"
                            />

                            <div
                              v-if="submitted && v$.category.color.$error"
                              class="invalid-feedback"
                            >
                              <span
                                v-if="v$.category.color.required.$message"
                                >{{ v$.category.color.required.$message }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="text-end pt-5 mt-3">
                        <b-button variant="light" @click="showModalEdit = false"
                          >Close</b-button
                        >
                        <b-button type="submit" variant="success" class="ms-1"
                          >Update Category</b-button
                        >
                      </div>
                    </form>
                  </b-modal>
                </div>
                <!-- MODAL EDIT -->
              </div>
            </div>
            <div class="table-responsive">
              <vue-good-table
                :search-options="{
                  enabled: true,
                }"
                :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  mode: 'records',
                }"
                :line-numbers="true"
                styleClass="tableOne vgt-table striped"
                :columns="columns"
                :rows="rows"
              >
                <template #table-row="props">
                  <span v-if="props.column.field == 'button'">
                    <b-button
                      size="sm"
                      variant="success"
                      @click="edit(props.formattedRow)"
                    >
                      <i
                        class="mdi mdi-pencil font-size-16 align-middle me-2"
                      ></i>
                      Edit
                    </b-button>
                  </span>
                  <span v-else-if="props.column.field == 'isActive'">
                    <b-form-checkbox
                      v-model="props.formattedRow.isActive"
                      name="check-button"
                      switch
                      @change="editStatus(props.formattedRow.uuid)"
                    >
                      <span
                        class="badge rounded-pill font-size-12 badge-soft-success"
                        v-if="props.formattedRow.isActive"
                        >On</span
                      >
                      <span
                        class="badge rounded-pill font-size-12 badge-soft-warning"
                        v-else
                        >Off</span
                      >
                    </b-form-checkbox>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style>
span.is-required {
  color: red;
}
</style>
